import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '../../../utils/webpack/chunkRetry';
import mobileChatWindowModalStyles from './MobileChatWindowModal.scss';
const MobileChatWindowModal = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "chatmobile" */ './index')));
const LoadableMobileChatWindowModal = (props)=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableMobileChatWindowModal"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama',
            className: mobileChatWindowModalStyles['loader']
        })
    }, /*#__PURE__*/ React.createElement(MobileChatWindowModal, props)));
};
LoadableMobileChatWindowModal.displayName = 'LoadableMobileChatWindowModal';
export default LoadableMobileChatWindowModal;

//# sourceMappingURL=LoadableMobileChatWindowModal.js.map